import { render, staticRenderFns } from "./TasksPanel.vue?vue&type=template&id=0fda5312&"
import script from "./TasksPanel.vue?vue&type=script&lang=js&"
export * from "./TasksPanel.vue?vue&type=script&lang=js&"
import style0 from "./TasksPanel.vue?vue&type=style&index=0&id=0fda5312&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports